'use strict'

import ReactDOM from "react-dom";
import App from "./components/public/app";


if(document.getElementById('app')){
    console.log('app');
    ReactDOM.render(<App />, document.getElementById('app'))
}